import React from 'react';
import { useGetTeamQuery } from '../../features/team/teamApi';

const HomeTeamSideBar = () => {
    const { data: teams, isError, isLoading, error } = useGetTeamQuery()
    let content = null;

    if (isLoading) {
        content = <li className="m-2 text-center">Loading...</li>;
    } else if (!isLoading && isError) {
        content = (
            <div >Error something is wrong</div>
        );
    } else if (!isLoading && !isError && teams?.length === 0) {
        content = <div className="m-2 text-center">No teams found!</div>;
    } else if (!isLoading && !isError && teams?.length > 0) {
        content = teams?.map(single => <div key={single.id} className="checkbox-container">
            <img src={single.avatar} className="team-avater" />
            <p className="label">{single.name}</p>
        </div>)
    }
    return (
        <div className="mt-8">
            <h3 className="text-xl font-bold">Team Members</h3>
            <div className="mt-3 space-y-4">


                {content}
            </div>
        </div>
    );
};

export default HomeTeamSideBar;